/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Document images (front/back)
 */
export type DocumentRequestDTO = {
    /**
     * Base64 encoded image content
     */
    imageContent?: string;
    /**
     * Type of document image (front/back)
     */
    imageType?: DocumentRequestDTO.imageType;
    /**
     * File extension of the image
     */
    mimeExt?: string;
};

export namespace DocumentRequestDTO {

    /**
     * Type of document image (front/back)
     */
    export enum imageType {
        DOCUMENT_FRONT_BASE64 = 'DOCUMENT_FRONT_BASE64',
        DOCUMENT_BACK_BASE64 = 'DOCUMENT_BACK_BASE64',
        SELFIE_BASE64 = 'SELFIE_BASE64',
        LIVENESS_BASE64 = 'LIVENESS_BASE64',
        PASSPORT_BIO_PAGE_BASE64 = 'PASSPORT_BIO_PAGE_BASE64',
    }


}

